import React, { useEffect } from "react";
import Lights from "./Lights";
import Timer from "./Timer";
import LoadingChart from "./LoadingChart";
import NextLoad from "./NextLoad";
import OrderTable from "./OrderTable";
import PositionChange from "./PositionChange";
import "./DisplayIndex.scss";
import { useMeet } from "util/useMeet";
import { usePlatform } from "util/usePlatform";
import { useCurrentLifter } from "util/useCurrentLifter";
import { useCurrentAttempt } from "util/useCurrentAttempt";
import { useKnownLiftingOrder } from "util/useKnownLiftingOrder";
import { useCompleteLiftingOrder } from "util/useCompleteLiftingOrder";
import { useFedConfig } from "util/useFedConfig";
import LifterName from "./LifterName";
import AttemptInfo from "./AttemptInfo";
import TeamName from "./TeamName";
import DivisionInfo from "./DivisionInfo";
import RecordInfo from "./RecordInfo";
import classNames from "classnames";
import { DisplaySettingsProvider } from "./DisplaySettingsProvider";
import { SettingsDrawer } from "./SettingsDrawer";
import NextOverlay from "./NextOverlay";
import CurrentOverlay from "./CurrentOverlay";
import Marquee from "./Marquee";

const DisplayIndex = () => {
  const meet = useMeet();
  const platform = usePlatform();
  const currentLifter = useCurrentLifter();
  const currentAttempt = useCurrentAttempt();
  const knownLiftingOrder = useKnownLiftingOrder();
  const completeLiftingOrder = useCompleteLiftingOrder();
  const federationConfig = useFedConfig();

  const [barChangeEvent, setBarChangeEvent] = React.useState(false);

  const barAndCollarsWeightRef = React.useRef(platform.barAndCollarsWeight);
  const barChangeEventTimer = React.useRef<NodeJS.Timeout | undefined>();
  useEffect(() => {
    if (platform.barAndCollarsWeight !== barAndCollarsWeightRef.current) {
      setBarChangeEvent(true);
      barAndCollarsWeightRef.current = platform.barAndCollarsWeight;
      barChangeEventTimer.current = setTimeout(() => {
        console.log("clearing");
        setBarChangeEvent(false);
      }, 5000);
    }

    return () => {
      if (barChangeEventTimer.current) {
        clearTimeout(barChangeEventTimer.current);
      }
    };
  }, [platform.barAndCollarsWeight]);

  useEffect(() => {
    if (meet.displayDefaultURL && !window.location.search) {
      window.location.search = meet.displayDefaultURL;
    }
  }, [meet.displayDefaultURL]);

  useEffect(() => {
    let backgroundStyle = "";

    if (meet.displayBackgroundImageUrl) {
      backgroundStyle = meet.displayBackgroundImageUrl
        ? `background: url(${meet.displayBackgroundImageUrl}) no-repeat fixed; background-size: cover;`
        : "";
    }

    document.body.setAttribute("style", backgroundStyle);

    return () => document.body.setAttribute("style", "");
  }, [meet.displayBackgroundImageUrl]);

  if (!platform || !meet) {
    return null;
  }

  return (
    <DisplaySettingsProvider>
      <div className={classNames("display-index2")}>
        <div className="display-settings-button">
          <SettingsDrawer />
        </div>
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <LifterName currentLifter={currentLifter} id="b" />
          <AttemptInfo meet={meet} currentAttempt={currentAttempt} id="a" />
          <TeamName meet={meet} currentLifter={currentLifter} id="t" />
          <DivisionInfo meet={meet} currentLifter={currentLifter} id="d" />
          <RecordInfo currentAttempt={currentAttempt} id="r" />
          <Timer platform={platform} id="time" />
          <PositionChange
            meet={meet}
            currentAttempt={currentAttempt}
            currentLifter={currentLifter}
            id="p"
          />
          <Lights meet={meet} platformId={platform._id} id="l" />
          <LoadingChart
            meet={meet}
            currentLifter={currentLifter}
            currentAttempt={currentAttempt}
            platform={platform}
            barChangeEvent={barChangeEvent}
            id="c"
          />
          <OrderTable
            meet={meet}
            platform={platform}
            completeLiftingOrder={completeLiftingOrder}
            id="o"
            federationConfig={federationConfig}
          />
          <NextLoad
            meet={meet}
            currentAttempt={currentAttempt}
            liftingOrder={knownLiftingOrder}
            platform={platform}
            id="n"
          />
          <NextOverlay id="no" platformId={platform._id} />
          <CurrentOverlay id="co" platformId={platform._id} />
          <Marquee
            meet={meet}
            currentLifter={currentLifter}
            currentAttempt={currentAttempt}
            id="m"
            platform={platform}
            barChangeEvent={barChangeEvent}
          />
        </div>
      </div>
    </DisplaySettingsProvider>
  );
};

export default DisplayIndex;
